import React from 'react'

import { SupportedMarketKey } from '@nxt-insurance/constants'

import { createFlowServerSideProps } from '@/app/utils/flows/createFlowServerSideProps'
import { getLiabilityFlowConfig } from '@/app/utils/flows/liabilityFlowConfig'
import { createFlowStepPage } from '@/shared/components/flows/FlowStepPage'
import type { FlowStepRouter } from '@/shared/components/flows/FlowStepPage/types'
import { trpc } from '@/utils/trpc'
import {
  LiabilityFamilyCoverageInfoAccordions,
  LiabilityInstantQuoteQuestions,
} from '@flows-ui/stepRenderer'

export const LIABILITY_FLOW = 'liability'

const LiabilityStep = createFlowStepPage({
  flowName: LIABILITY_FLOW,
  productKey: 'liability_v1_getsafe_de',
  quoteStepName: 'liability_quote',
  i18nNamespace: 'sharedFlows_liabilityNxt',
  router: trpc.liabilityFlow as FlowStepRouter,
  useUtils: () => trpc.useUtils().liabilityFlow,
  getConfig: getLiabilityFlowConfig,
  supportsPermanentDiscount: true,
  extraComponents: ({ getProductGeneration }) => ({
    LiabilityInstantQuoteQuestions,
    LiabilityFamilyCoverageInfoAccordions: () => (
      <LiabilityFamilyCoverageInfoAccordions extensions={getProductGeneration()?.extensions} />
    ),
  }),
})

export const getServerSideProps = createFlowServerSideProps({
  flowNamePath: LIABILITY_FLOW,
  market: SupportedMarketKey.De,
  translationNamespace: 'sharedFlows_liabilityNxt',
  getConfig: getLiabilityFlowConfig,
})

export default LiabilityStep
